import React, { useState } from 'react';
import * as XLSX from 'xlsx';

const Sorteo = () => {
  const [participantes, setParticipantes] = useState([]);
  const [ganador, setGanador] = useState(null);
  const [estaSorteando, setEstaSorteando] = useState(false);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      
      const data = XLSX.utils.sheet_to_json(ws);
      
      const listaNombres = data
        .map(fila => fila["Nombre Completo"])
        .filter(nombre => nombre && String(nombre).trim() !== "");
      
      setParticipantes(listaNombres);
      setGanador(null);
    };
    reader.readAsBinaryString(file);
  };

  const realizarSorteo = () => {
    if (participantes.length === 0) return;

    setEstaSorteando(true);
    setGanador(null);

    let iteraciones = 0;
    const intervalo = setInterval(() => {
      const indexProvisional = Math.floor(Math.random() * participantes.length);
      setGanador(participantes[indexProvisional]);
      iteraciones++;

      if (iteraciones > 20) {
        clearInterval(intervalo);
        const indiceFinal = Math.floor(Math.random() * participantes.length);
        setGanador(participantes[indiceFinal]);
        setEstaSorteando(false);
      }
    }, 100);
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Sorteo SUBCAFAE</h1>
      
      <div style={styles.card}>
        <label style={styles.label}>Cargar Excel de Participantes:</label>
        <input 
          type="file" 
          accept=".xlsx, .xls, .csv" 
          onChange={handleFileUpload} 
          style={styles.input}
        />
      </div>

      {participantes.length > 0 && (
        <div style={styles.actionSection}>
          <p>Total de participantes: <strong>{participantes.length}</strong></p>
          <button 
            onClick={realizarSorteo} 
            disabled={estaSorteando}
            style={{...styles.button, backgroundColor: estaSorteando ? '#ccc' : '#e63946'}}
          >
            {estaSorteando ? 'Sorteando...' : '¡ELEGIR GANADOR!'}
          </button>
        </div>
      )}

      {ganador && (
        <div style={styles.winnerBox}>
          <h2 style={styles.winnerLabel}>{estaSorteando ? 'Buscando...' : '¡GANADOR(A)!'}</h2>
          <div style={styles.winnerName}>{ganador}</div>
        </div>
      )}

      {participantes.length > 0 && (
        <div style={styles.listSection}>
          <h3>Lista Cargada:</h3>
          <div style={styles.scrollList}>
            {participantes.map((n, i) => (
              <div key={i} style={styles.listItem}>{i + 1}. {n}</div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// Estilos modernos
const styles = {
  container: { maxWidth: '800px', margin: '40px auto', fontFamily: 'Segoe UI, sans-serif', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' },
  title: { textAlign: 'center', color: '#1d3557', marginBottom: '30px' },
  card: { backgroundColor: '#fff', padding: '20px', borderRadius: '10px', marginBottom: '20px', border: '1px solid #dee2e6' },
  label: { display: 'block', marginBottom: '10px', fontWeight: 'bold' },
  input: { width: '100%' },
  actionSection: { textAlign: 'center', margin: '30px 0' },
  button: { padding: '15px 40px', fontSize: '1.5rem', color: '#fff', border: 'none', borderRadius: '50px', cursor: 'pointer', transition: '0.3s' },
  winnerBox: { backgroundColor: '#f1faee', border: '3px solid #457b9d', padding: '40px', borderRadius: '15px', textAlign: 'center', margin: '20px 0', animation: 'fadeIn 0.5s' },
  winnerLabel: { margin: 0, color: '#457b9d', fontSize: '1.2rem' },
  winnerName: { fontSize: '2.5rem', fontWeight: 'bold', color: '#1d3557', marginTop: '10px' },
  listSection: { marginTop: '40px' },
  scrollList: { maxHeight: '300px', overflowY: 'auto', backgroundColor: '#fff', padding: '10px', borderRadius: '8px', border: '1px solid #eee' },
  listItem: { padding: '5px 10px', borderBottom: '1px solid #f1f1f1', fontSize: '0.9rem' }
};

export default Sorteo;